import convertSnakeCaseToTitleCase from '../../../lib/helper-functions/convertSnakeCaseToTitleCase';

/**
 * Credential fields a platform accepts but does not need. Every other field
 * in a platform's `credentials_fields` must be filled in to save.
 */
const OPTIONAL_FIELDS_BY_PLATFORM: Record<string, string[]> = {
  google_ads: ['MANAGER_ACCOUNT_ID'],
  triplewhale: ['TRIPLEWHALE_SHOP_ID'],
  mixpanel: ['MIXPANEL_MCP_URL'],
};

export const TRIPLEWHALE_MCP_SLUG = 'triplewhale';
export const TRIPLEWHALE_STORE_FIELD = 'TRIPLEWHALE_SHOP_ID';

/** Whether the form may be saved with this field of the platform left empty. */
export function isOptionalMcpField(
  platformSlug: string | null | undefined,
  field: string
): boolean {
  if (!platformSlug) {
    return false;
  }
  return (OPTIONAL_FIELDS_BY_PLATFORM[platformSlug] ?? []).includes(field);
}

/**
 * Labels for credential fields whose title-cased name reads wrong
 * (brand names, acronyms). Every other field falls back to title case.
 */
const FIELD_LABEL_OVERRIDES: Record<string, string> = {
  TRIPLEWHALE_API_KEY: 'Triple Whale API key',
};

/** The display label for a credential field name. */
export function mcpFieldLabel(field: string): string {
  return FIELD_LABEL_OVERRIDES[field] ?? convertSnakeCaseToTitleCase(field);
}

/** The Triple Whale store field, which has its own label and hint. */
export function isTriplewhaleStoreField(
  platformSlug: string | null | undefined,
  field: string
): boolean {
  return (
    platformSlug === TRIPLEWHALE_MCP_SLUG && field === TRIPLEWHALE_STORE_FIELD
  );
}
